import React from 'react';
import { Row, Col, Container, Button } from 'reactstrap';
import FireFox from '../../assets/icons/firefox.svg';
import Opera from '../../assets/icons/opera.svg';
import Chrome from '../../assets/icons/google_chrome.svg';


//If using internet exploret provide new browser options

export const ProvideBrowserOptions = () => {

    return (
        <Container className="center" style={{ fontFamily: 'Titillium Web' }}>
            <Row style={{ textAlign: 'center' }}>
                <Col>
                    <h1>Jirango does not support Internet explorer!</h1>
                </Col>
            </Row>
            <Row style={{ textAlign: 'center' }}>
                <Col>
                    <p>The page you are looking for is not supported in the browser you are currently using, Internet Explorer.

Internet Explorer has security issues and is no longer supported my Microsoft.



If you came here from a link in an email, read this article to change the way links are opened in Outlook.





                    </p>

                    <a href="https://ittutorials.net/microsoft/windows-7/set-outlook-to-open-links-on-a-different-browser/" >
                        Read more
</a>
                    <br /><br/>
                    <p>
                        The following browsers are supported – click one of the options below to download and install.</p>
                </Col>
            </Row>
            <br />
            <Row style={{ textAlign: 'center' }}>
                <Col style={{ cursor: 'pointer' }} onClick={
                    () => window.location.replace("https://www.google.com/intl/sv/chrome/")
                }>
                    <img height={100} width={100} src={Chrome} /><br /><br />
                    <a color="primary">

                        Google Chrome
                    </a>
                </Col>
                <Col style={{ cursor: 'pointer' }} onClick={
                    () => window.location.replace("https://www.opera.com")
                }>
                    <img height={100} width={100} src={Opera} /><br /><br />
                    <a color="primary"

                    >
                        Opera
                        </a>
                </Col>
                <Col style={{ cursor: 'pointer' }} onClick={
                    () => window.location.replace("https://www.mozilla.org/sv-SE/firefox/new/")
                }>
                    <img height={100} width={100} src={FireFox} /><br /><br />
                    <a color="primary" >FireFox</a>
                </Col>
            </Row>
        </Container >
    )
}